import type {
  ManagedProjectOption,
  ProjectWorkItemFormValue,
} from '@/types/report-project-work-item-lite';

export function createProjectWorkItemClientKey(): string {
  return `pwi-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/** 添加块时分配 sortOrder */
export function nextProjectWorkItemSortOrder(items: ProjectWorkItemFormValue[]): number {
  if (items.length === 0) {
    return 0;
  }
  return Math.max(...items.map((item) => item.sortOrder)) + 1;
}

/** 删除块后压缩 sortOrder 为 0..n-1（Frozen L4 推荐） */
export function compactProjectWorkItemSortOrder(
  items: ProjectWorkItemFormValue[],
): ProjectWorkItemFormValue[] {
  return [...items]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((item, index) => ({ ...item, sortOrder: index }));
}

/** Frozen L2：可选项目 = PM 项目 − 已选 projectId */
export function filterSelectableManagedProjects(
  managedProjects: ManagedProjectOption[],
  selectedProjectIds: ReadonlySet<string>,
): ManagedProjectOption[] {
  return managedProjects.filter((project) => !selectedProjectIds.has(project.id));
}

export function buildSelectedProjectIdSet(items: ProjectWorkItemFormValue[]): Set<string> {
  return new Set(items.map((item) => item.projectId));
}

/** 校验项目块（T3 提交编排复用） */
export function validateProjectWorkItems(
  items: ProjectWorkItemFormValue[],
): string | null {
  const seen = new Set<string>();
  for (const item of items) {
    if (seen.has(item.projectId)) {
      return '同一份日报内不能重复选择同一项目';
    }
    seen.add(item.projectId);
    if (!item.progressContent.trim()) {
      return `请填写「${item.projectName}」的项目进展`;
    }
    if (item.progressPercent < 0 || item.progressPercent > 100) {
      return `「${item.projectName}」汇报进度须在 0～100 之间`;
    }
  }
  return null;
}

export function createProjectWorkItemFromOption(
  project: ManagedProjectOption,
  sortOrder: number,
): ProjectWorkItemFormValue {
  return {
    clientKey: createProjectWorkItemClientKey(),
    projectId: project.id,
    projectName: project.name,
    sortOrder,
    progressPercent: project.progress ?? 0,
    progressContent: '',
    problemContent: '',
    nextPlanContent: '',
  };
}
